'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'ADDTHIS_SOCIAL_BUTTONS',
	name: 'Social buttons',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Social',
	props: [{
		name: 'pubid',
		inputType: 'text',
		label: 'Addthis id',
		default: ''
	}, {
		name: 'type',
		inputType: 'select',
		label: 'Button type',
		default: 'follow',
		values: ['follow', 'share']
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Advanced settings',
		props: [{
			name: 'gutter',
			inputType: 'slider',
			label: 'Gutter size',
			default: 3,
			min: 0,
			max: 50
		}]
	})
};